import type { ILeadsSearchFiltersDto } from "app/pages/sales-intelligence/modules/leads-search-filters";
import type { ContactProfileDtoList } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/dto";
import type Signal from "app/pages/sales-intelligence/sub-modules/signals/models/core/Signal";

import { ApplicationStateChangeType, type IApplicationStatePayload } from "../../types/dto";

export const applicationStateSyncService = {
    createSignalsListChangePayload: (signals: readonly Signal[]): IApplicationStatePayload => ({
        state: { signals },
        context: {
            changeType: ApplicationStateChangeType.SignalsListChange,
        },
    }),

    createSignalDraftCreateAndApplyPayload: (
        signals: readonly Signal[],
        filtersState: Partial<ILeadsSearchFiltersDto>,
    ): IApplicationStatePayload => ({
        state: { signals, filtersState },
        context: {
            changeType: ApplicationStateChangeType.SignalDraftCreateAndApply,
        },
    }),

    createSignalLifecycleChangePayload: (signal: Signal): IApplicationStatePayload => ({
        state: { signals: [signal] },
        context: {
            changeType: ApplicationStateChangeType.SignalLifecycleChange,
        },
    }),

    createEmployeeProfilesChangePayload: (employeeProfiles: ContactProfileDtoList): IApplicationStatePayload => ({
        state: { employeeProfiles },
        context: {
            changeType: ApplicationStateChangeType.EmployeeProfileListChange,
        },
    }),

    createFiltersStateChangePayload: (filtersState: Partial<ILeadsSearchFiltersDto>): IApplicationStatePayload => ({
        state: { filtersState },
        context: {
            changeType: ApplicationStateChangeType.FilterListChange,
        },
    }),
};
